import { isProtectedCapability, scopeRank } from './capabilities.js';
function grantFor(actor, capability) {
    return actor.grants.find((x) => x.capability === capability);
}
/** Есть ли право хотя бы в какой-то области. Для гейтинга элементов интерфейса. */
export function hasCapability(actor, capability) {
    const grant = grantFor(actor, capability);
    return grant !== undefined && grant.scope !== 'none';
}
export function scopeOf(actor, capability) {
    return grantFor(actor, capability)?.scope ?? 'none';
}
/**
 * Основная проверка. Без `resource` отвечает на вопрос «право есть в принципе»,
 * с `resource` — «право применимо к этому объекту».
 */
export function can(actor, capability, resource) {
    const scope = scopeOf(actor, capability);
    if (scope === 'none')
        return false;
    if (resource === undefined)
        return true;
    // Межтенантный доступ невозможен ни при какой области.
    // Кросс-организационный аудитор получает отдельный Actor на каждую организацию.
    if (resource.orgId !== actor.orgId)
        return false;
    switch (scope) {
        case 'org':
            return true;
        case 'site': {
            if (actor.siteIds === null)
                return true;
            const siteId = resource.siteId;
            return siteId != null && actor.siteIds.includes(siteId);
        }
        case 'own':
            return resource.ownerId != null && resource.ownerId === actor.userId;
    }
}
/**
 * Правило подмножества. CLAUDE.md, правило 15.
 * Нельзя вложить в роль или назначить права, которых нет у самого actor.
 * Проверяется ОТДЕЛЬНО при создании роли и при её назначении — это разные операции.
 */
export function isSubsetOfGrants(candidate, reference) {
    return candidate.every((wanted) => {
        if (wanted.scope === 'none')
            return true;
        const held = reference.find((x) => x.capability === wanted.capability);
        if (held === undefined)
            return false;
        return scopeRank(held.scope) >= scopeRank(wanted.scope);
    });
}
/** Проверка набора прав для КАСТОМНОЙ роли — с учётом защищённых прав. */
export function validateCustomRoleGrants(candidate, actor) {
    const issues = [];
    for (const wanted of candidate) {
        if (wanted.scope === 'none')
            continue;
        if (isProtectedCapability(wanted.capability)) {
            issues.push({
                code: 'protected_capability',
                capability: wanted.capability,
                message: 'This permission is available to system roles only.',
            });
            continue;
        }
        const held = actor.grants.find((x) => x.capability === wanted.capability);
        if (held === undefined || scopeRank(held.scope) < scopeRank(wanted.scope)) {
            issues.push({
                code: 'exceeds_actor_grants',
                capability: wanted.capability,
                message: 'You cannot grant a permission broader than your own.',
            });
        }
    }
    return issues;
}
/** Можно ли actor назначить роль с таким уровнем и правами. */
export function canAssignRole(actor, role) {
    if (!hasCapability(actor, 'user:role:grant'))
        return false;
    if (role.level > actor.level)
        return false;
    return isSubsetOfGrants(role.grants, actor.grants);
}
//# sourceMappingURL=authorize.js.map